import { Component, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { StateService } from '@services/state.service';

/*Models */
import { DeviceState } from '@models/device-state';
import { Device } from '@models/device';
/*Plugins */
import { OwlCarousel } from 'ngx-owl-carousel';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'indicator-device',
  templateUrl: './indicator-device.component.html'
})
export class IndicatorDeviceComponent implements OnDestroy {

  @ViewChild('statesSlider') statesSlider: OwlCarousel;
  public sliderStatesOptions: any;
  additionalStates: Array<any> = [];
  state: DeviceState;
  public currentDevice: Device;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public stateService: StateService
  ) {

    this.currentDevice = this.stateService.currentDevice;

    this.stateService.currentDeviceSubject
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
      });
    this.stateService.observableObjectObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(object => {
        if (this.statesSlider) {
          this.statesSlider.to([0, 0]);
        }

      });
    this.stateService.stateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(state => {

        /*compare two arrays */
        if (this.state) {

          /*update time */
          this.state.additionalStates.time = state.additionalStates.time;
          if (JSON.stringify(this.state.additionalStates) !== JSON.stringify(state)) {

            this.state = state;
            this.setAdditionlaState();
          }
        } else {

          this.state = state;
          this.setAdditionlaState();
        }
        if (this.statesSlider) {
          this.statesSlider.trigger('refresh');
        }


      });

    this.sliderStatesOptions = {
      dots: false,
      navigation: true,
      nav: true,
      navText: ['', ''],
      navClass: ['car-details-tabs-prev', 'car-details-tabs-next'],
      loop: false,
      lazyLoad: false,
      responsive: {
        0: { items: 5 },
        600: { items: 5 },
        1000: { items: 5 }
      }
    };


  }

  setAdditionlaState() {
    this.additionalStates = [];
    if (this.currentDevice.provider.toLowerCase() === 'magicsystems' && this.currentDevice.deviceType === 'beacon') {
      if (this.state.additionalStates.voltage && this.state.additionalStates.voltage.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.voltage.value,
          unit: this.state.additionalStates.voltage.units,
          nameRus: 'Заряд аккумулятора',
          type: 'voltage',
          hasGraph: true
        });
      }
      if (this.state.additionalStates.gsmLevel && this.state.additionalStates.gsmLevel.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.gsmLevel.value,
          unit: this.state.additionalStates.gsmLevel.units,
          nameRus: 'Уровень GSM',
          type: 'gsmLevel'
        });
      }
    } else {
      if (this.state.additionalStates.fuel && this.state.additionalStates.fuel.value) {
        this.additionalStates.push({
          // type
          value: this.state.additionalStates.fuel.value,
          unit: this.state.additionalStates.fuel.units,
          nameRus: 'Бензин',
          type: 'fuel',
          hasGraph: true
        });
      }
      if (this.state.additionalStates.voltage && this.state.additionalStates.voltage.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.voltage.value,
          unit: this.state.additionalStates.voltage.units,
          nameRus: 'Заряд аккумулятора',
          type: 'voltage',
          hasGraph: true
        });
      }
      if (this.state.additionalStates.reservedVoltage && this.state.additionalStates.reservedVoltage.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.reservedVoltage.value,
          unit: this.state.additionalStates.reservedVoltage.units,
          nameRus: 'Резервный заряд',
          type: 'reservedVoltage',
          hasGraph: true
        });
      }
      if (this.state.additionalStates.cardVoltage && this.state.additionalStates.cardVoltage.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.cardVoltage.value,
          unit: this.state.additionalStates.cardVoltage.units,
          nameRus: 'Заряд метка',
          type: 'cardVoltage'
        });
      }
      if (this.state.additionalStates.balance && this.state.additionalStates.balance.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.balance.value,
          unit: this.state.additionalStates.balance.units,
          nameRus: 'Баланс',
          type: 'balance',
          hasGraph: true
        });
      }
      if (this.state.additionalStates.temperatureOut && this.state.additionalStates.temperatureOut.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.temperatureOut.value,
          unit: this.state.additionalStates.temperatureOut.units,
          nameRus: 'Температура за бортом',
          type: 'temperatureOut'
        });
      }
      if (this.state.additionalStates.temperatureEngine && this.state.additionalStates.temperatureEngine.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.temperatureEngine.value,
          unit: this.state.additionalStates.temperatureEngine.units,
          nameRus: 'Температура двигателя',
          type: 'temperatureEngine',
          hasGraph: true
        });
      }
      if (this.state.additionalStates.temperatureIn && this.state.additionalStates.temperatureIn.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.temperatureIn.value,
          unit: this.state.additionalStates.temperatureIn.units,
          nameRus: 'Температура в салоне',
          type: 'temperatureIn'
        });
      }
      if (this.state.additionalStates.temperatureMain && this.state.additionalStates.temperatureMain.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.temperatureMain.value,
          unit: this.state.additionalStates.temperatureMain.units,
          nameRus: 'Температура основная',
          type: 'temperatureMain'
        });
      }
      if (this.state.additionalStates.cardLevel && this.state.additionalStates.cardLevel.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.cardLevel.value,
          unit: this.state.additionalStates.cardLevel.units,
          nameRus: 'Уровень метки',
          type: 'cardLevel'
        });
      }
      if (this.state.additionalStates.gsmLevel && this.state.additionalStates.gsmLevel.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.gsmLevel.value,
          unit: this.state.additionalStates.gsmLevel.units,
          nameRus: 'Уровень GSM',
          type: 'gsmLevel'
        });
      }
      if (this.state.additionalStates.satelites && this.state.additionalStates.satelites.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.satelites.value,
          unit: this.state.additionalStates.satelites.units,
          nameRus: 'Спутники',
          type: 'satelites'
        });
      }
      if (this.state.additionalStates.speed && this.state.additionalStates.speed.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.speed.value,
          unit: this.state.additionalStates.speed.units,
          nameRus: 'Cкорость',
          type: 'speed'
        });
      }
      if (this.state.additionalStates.mileage && this.state.additionalStates.mileage.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.mileage.value,
          unit: this.state.additionalStates.mileage.units,
          nameRus: 'Одометр',
          type: 'mileage',
          hasGraph: true
        });
      }
      if (this.state.additionalStates.rpm && this.state.additionalStates.rpm.value) {
        this.additionalStates.push({
          value: this.state.additionalStates.rpm.value,
          unit: this.state.additionalStates.rpm.units,
          nameRus: 'Тахометр',
          type: 'rpm',
          hasGraph: true
        });
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/components/indicator-device/indicator-device.component.ts